import React from "react";
import { useRouter } from "./common/Router";
import LoginForm from "./login/LoginForm";
import LayoutContainer from "./common/LayoutContainer";
import LegalFooter from "./common/LegalFooter";
import LanguageContainer from "./common/LanguageContainer";
import PageLocationTag from "./common/PageLocationTag";
import HeaderLogin from "./common/HeaderLogin";
import HistoryBackProcessor from "./universal-login/HistoryBackProcessor";

const LoginContainerCSR: React.FC = () => {
  const { loc } = useRouter();

  return (
    <LanguageContainer>
      <PageLocationTag pageLocationTag={loc} />
      <HistoryBackProcessor />
      <HeaderLogin />
      <LayoutContainer>
        <LoginForm />
        <LegalFooter />
      </LayoutContainer>
    </LanguageContainer>
  );
};
export default LoginContainerCSR;
